import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Box
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { fetchAsyncAddOrgnization } from "redux/organizationSlice";
import { EMAIL_REGEX, GST_REGEX, MAX_GST_LENGTH, MAX_PAN_LENGTH, PAN_REGEX, PHONE_REGEX } from "../regexPattern";
import { fetchAsyncUpdateOrganization } from "redux/organizationSlice";
import { createDefaultOption } from "jsFunctions/helperFunctions";
import CustomSelect from "../customSelect";
import { fetchAsyncGetPricing } from "redux/pricingSlice";

const OrganizationForm = ({ openModel, closeModel, editData, isEdit, refreshList }) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [pricingTypeOption,setPricingTypeOption] = useState([])
  
  const [formData, setFormData] = useState({
    name: '',
    orgType:{},
    email: '',
    password: '',
    gstNumber: '',
    panNumber: '',
    phone: ''
  });

  const [errors, setErrors] = useState({});
  const pricingList = useSelector((state) => state.pricingData);

  useEffect(()=>{
    dispatch(fetchAsyncGetPricing())
  },[])

  const getAllPricingOptions = async()=>{
      const pricingOption = await createDefaultOption('name','_id',pricingList) 
      setPricingTypeOption(pricingOption);
  }
 
  useEffect(()=>{
    if(pricingList){
      getAllPricingOptions()
    }
  },[pricingList])
  
  useEffect(() => {
    if (isEdit && editData) {
      const orgTyp = pricingTypeOption.find((opt)=>opt.value === editData?.orgTyp?._id)
      setFormData({
        name: editData?.name,
        orgType:orgTyp || {},
        email: editData?.mail,
        userName: editData?.uName,
        password: editData?.pass,
        gstNumber: editData?.gstNo,
        panNumber: editData?.pnNo,
        phone: editData?.ph
      });
    }
  }, [isEdit, editData,pricingTypeOption]);

  const toCamelCase = (value) => {
    return value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === "panNumber" || name === "gstNumber") {
      formattedValue = value.toUpperCase();
      if (name === "panNumber" && formattedValue.length > MAX_PAN_LENGTH) {
        return;
      }
      if (name === "gstNumber" && formattedValue.length > MAX_GST_LENGTH) {
        return;
      }

      if (name === "gstNumber" && GST_REGEX.test(formattedValue)) {
        const extractedPan = formattedValue.substring(2, 12);
        setFormData((prev) => ({
          ...prev,
          panNumber: extractedPan
        }));
      }
    } else if (name === "email") {
      formattedValue = value.toLowerCase();
    } else {
      formattedValue = toCamelCase(value);
    }

    if (name === "phone") {
      if (!formattedValue || PHONE_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, phone: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phone: "Phone number must be 10 digits..",
        }));
      }
    }
    if (name === "email") {
      if (!formattedValue || EMAIL_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, email: "" }));
      } else {
        setErrors((prev) => ({ ...prev, email: "Email format is invalid." }));
      }
    }
    if (name === "gstNumber") {
      if (!formattedValue || GST_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, gstNumber: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          gstNumber: "GST Number format is invalid",
        }));
      }
    }
    if (name === "panNumber") {
      if (!formattedValue || PAN_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, panNumber: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          panNumber: "PAN Number format is invalid.",
        }));
      }
    }

   
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Organization Name is required';
    if(!isEdit){

      if (!formData.email) newErrors.email = 'Email is required';
      else  if (formData.email && !EMAIL_REGEX.test(formData.email)) {
        newErrors.email = "Email format is invalid.";
      }
      if (!formData.password) newErrors.password = 'Password is required';
    }
    
    if (formData.phone && !PHONE_REGEX.test(formData.phone)) {
      newErrors.phone = "Phone number must be 10 digits.";
    }
    if (formData.gstNumber && !GST_REGEX.test(formData.gstNumber)) {
      newErrors.gstNumber = "GST Number format is invalid";
    }
    if (formData?.panNumber && !PAN_REGEX.test(formData.panNumber)) {
      newErrors.panNumber = "PAN Number format is invalid.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleAddOrganization = () => {
    dispatch(fetchAsyncAddOrgnization(formData))
      .then((res) => {
        if (res?.payload) {
          refreshList();
          closeModel();
          addToast(`New organization has been created successfully!`, { appearance: "success" });
        }
        else{
          const msg = res?.error?.message || "Error creating organization"
          addToast(msg, { appearance: "error" });
        }
      })
      .catch((err) => {
        addToast("Error creating organization", { appearance: "error" });
      });
  };

  const handleEditOrganization = () => {
    dispatch(fetchAsyncUpdateOrganization({ id: editData._id, editData: formData }))
      .then((res) => {
        if (res?.payload) {
          refreshList();
          closeModel();
          addToast(`Organization details have been updated successfully!`, { appearance: "success" });
        }
        else{
          const msg = res?.error?.message || "Error updating organization"
          addToast(msg, { appearance: "error" });

        }
      })
      .catch((err) => {
        addToast("Error updating organization", { appearance: "error" });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (!isEdit) {
        handleAddOrganization();
      } 
      else{
        handleEditOrganization()
      }
    }
  };

  const finalRef = useRef(null);

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openModel}
        onClose={closeModel}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
        top="0" 
        margin="0 auto" 
        maxH="-webkit-max-content"
        // bottom="0"
        className="add-form-modal-content"
        >
           <div className="fixed-header">
            <ModalHeader className="modal-heading expense-modal-header">
              {isEdit ? "Edit" : "Add"} Organization
            </ModalHeader>
            <ModalCloseButton />
          </div>
          <ModalCloseButton />
          <ModalBody>
            <Form className="addForm">
            <div className="form-card">
              <Row>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label><span className="span-star">Organization Name*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Organization Name"
                      value={formData?.name}
                      disabled={isEdit}

                      name='name'
                      isInvalid={!!errors?.name}
                      onChange={handleOnChange}
                    />
                  </Box>
                  <p className="form_error">{errors?.name}</p>
                </Col>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label><span className="span-star">Organization Type*</span></Form.Label>
                    <CustomSelect
                          options={pricingTypeOption}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) => {
                            setFormData({
                              ...formData,
                              orgType:newValue
                            })
                          }}
                          isSearchable
                          defaultValue={formData?.orgType}
                          name="orgType"
                        />
                  </Box>
                </Col>
              </Row>
              </div>
              {!isEdit 
              &&
              <Row>

              <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label><span className="span-star">Email*</span></Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      value={formData.email}
                      name='email'
                      disabled={isEdit}
                      isInvalid={!!errors.email}
                      onChange={handleOnChange}
                    />
                  </Box>
                  <p className="form_error">{errors.email}</p>
                </Col>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label><span className="span-star">Password*</span></Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter Password"
                      value={formData.password}
                      disabled={isEdit}

                      name='password'
                      isInvalid={!!errors.password}
                      onChange={handleOnChange}
                    />
                  </Box>
                  <p className="form_error">{errors.password}</p>
                </Col>
                
              </Row>
              }
              <Row>
             
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>GST Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter GST Number"
                      value={formData.gstNumber}
                      name='gstNumber'
                      onChange={handleOnChange}
                    />
                  </Box>
                  <p className="form_error">{errors.gstNumber}</p>

                </Col>
                
              <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>Pan Number</Form.Label>
                    <Form.Control
                      type="text"
                      // placeholder="Enter PAN Number"
                      value={formData.panNumber}
                      name='panNumber'
                      disabled
                      onChange={handleOnChange}
                    />
                  </Box>
                  <p className="form_error">{errors.panNumber}</p>

                </Col>
              </Row>
              <Row>
                
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="Number"
                      placeholder="Enter Phone Number"
                      value={formData.phone || ""}
                      name='phone'
                      onChange={handleOnChange}
                    />

                  </Box>
                    <p className="form_error">{errors.phone}</p>
                </Col>
                {isEdit ?
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label><span className="span-star">Email*</span></Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      value={formData.email}
                      name='email'
                      disabled={isEdit}
                      isInvalid={!!errors.email}
                      onChange={handleOnChange}
                    />
                  </Box>
                  <p className="form_error">{errors.email}</p>
                </Col>
                :
                <Col></Col>
                }
              </Row>
              <Row className="role_add_btn">
                <Button
                  variant="brand"
                  type="submit"
                  className="submit-btn mt-1 px-4"
                  onClick={(e)=>handleSubmit(e)}
                >
                  Submit
                </Button>
              </Row>
            </Form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default OrganizationForm;